import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import Home24Plan from './Home24Plan.vue'
registerVueComponentAndAngularBindings('home24:plan', 'home24Plan', Home24Plan);